import { dateDiff } from "helpers/datetime";
import { useEffect, useState, Fragment } from "react";
import { useIntl } from "react-intl";
import { Box } from "@mui/material";

type Props = {
  startTime: string;
  endTime: string;
  hideAgo?: boolean;
};

type TimeType = { type: string; value: number };

const TimeDiff = ({ startTime, endTime, hideAgo }: Props) => {
  const t = useIntl();
  
  const [timediff, setDatediff] = useState<TimeType[]>([]);
  const [isJustNow, setIsJustNow] = useState(false);

  useEffect(() => {
    let dateDiffObj = {};

    // Return early if either startTime or endTime is null/undefined
    if (!startTime || !endTime) {
      setDatediff([]);
      setIsJustNow(false);
      return;
    }

    try {
      dateDiffObj = dateDiff(startTime, endTime);
    } catch (error) {
      console.log(error);
      setIsJustNow(false);
      return;
    }

    type keyType = keyof typeof dateDiffObj;
    const objKeys = Object.keys(dateDiffObj)
      .filter((key: string) => dateDiffObj[key as keyType] > 0)
      .map((key) => ({ type: key, value: dateDiffObj[key as keyType] }));

    // Check if there's no significant time difference (just now case)
    if (objKeys.length === 0) {
      setIsJustNow(true);
      setDatediff([]);
    } else {
      setIsJustNow(false);
      setDatediff(objKeys);
    }
  }, [startTime, endTime]);

  // Return empty box with fixed height if invalid inputs
  if (!startTime || !endTime) {
    return <Box sx={{ height: "1em", display: "inline-block" }} />;
  }

  // Show "just now" when there's no time difference
  if (isJustNow) {
    return (
      <Fragment>
        {t.formatMessage({
          id: "just_now",
        })}
      </Fragment>
    );
  }

  // Return empty box if no time difference data
  if (timediff.length === 0) {
    return <Box sx={{ height: "1em", display: "inline-block" }} />;
  }

  return (
    <Fragment>
      {timediff.map(
        ({ value, type }) =>
          (value > 0 ? value + " " : "") +
          (t.formatMessage({
            id: value > 1 ? `${type}s` : type,
          }) +
            " ")
      )}

      {timediff.length > 0 && !hideAgo
        ? " " +
          t.formatMessage({
            id: "ago",
          })
        : ""}
    </Fragment>
  );
};

export default TimeDiff;